import React from 'react';
import { Youtube, Linkedin } from 'lucide-react';
import { companyInfo } from '../mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/in/timmanna-gudi-3b817815',
      icon: Linkedin,
      color: 'hover:bg-blue-600',
      bgColor: 'bg-blue-700'
    },
    {
      name: 'YouTube',
      url: 'https://youtube.com/@tngudi2951?si=aJByRd6hsghtNp_1',
      icon: Youtube,
      color: 'hover:bg-red-600',
      bgColor: 'bg-red-700'
    }
  ];

  return (
    <footer className="bg-slate-950 text-white py-12 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center gap-6">
          {/* Company Info */}
          <div className="text-center">
            <h3 className="text-xl font-bold mb-2">
              Tek S<span className="text-orange-500">o</span>luti<span className="text-orange-500">o</span>ns and C<span className="text-orange-500">o</span>nsultants
            </h3>
            <p className="text-gray-400 text-sm">
              Precision Engineered Vulcanizing Solutions
            </p>
          </div>

          {/* Social Media Buttons */}
          <div className="flex gap-4">
            {socialLinks.map((social) => {
              const Icon = social.icon;
              return (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${social.bgColor} ${social.color} p-3 rounded-full transition-all duration-300 hover:scale-110 shadow-lg hover:shadow-xl`}
                  aria-label={social.name}
                >
                  <Icon size={24} className="text-white" />
                </a>
              );
            })}
          </div>

          {/* Copyright */}
          <div className="text-center border-t border-slate-800 pt-6 w-full">
            <p className="text-gray-400 text-sm">
              © {currentYear} {companyInfo.name}. All rights reserved.
            </p>
            <p className="text-gray-500 text-xs mt-1">
              Manufacturer of Vulcanizing Machines & Accessories
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
